import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';

import request from '../../../utils/request';
import {
  contentfulFormConfig,
  getBusinessAppFormStepFields
} from '../../../contentful';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';
import OrderDetails from '../../orderDetails';

const ViewOrder = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { viewOrderButtonLabel }
  } = localizedStrings;

  const { id, locale } = orderData;
  const { role_id: role } = request.getProfile();
  const isSalesManager = role === 7;
  const isSalesSupport = role === 11;
  const isAdmin = role === 1;
  const isSalesRep = role === 2;
  const userRights = {
    isStatusEditable: false,
    canAssignOrder: false,
    canAddComments: false,
    canPerformAction: false
  };

  const [isOderDetailsOpen, setIsOrderDetailsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [orderSummary, setOrderSummary] = useState(null);
  const [orderComments, setOrderComments] = useState(null);

  const handleViewOrder = async () => {
    setIsLoading(true);
    const {
      data: { results: comments }
    } = await request.get(`/orders/${id}/comments`);
    setOrderComments(comments);

    const config = { ...contentfulFormConfig, locale };
    getBusinessAppFormStepFields(config, summary => {
      setOrderSummary(summary);
      setIsLoading(false);
      setIsOrderDetailsOpen(true);
    });
  };

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Loading order details.."
        spinning={isLoading}
      />
      {orderSummary && (
        <OrderDetails
          open={isOderDetailsOpen}
          setOpen={setIsOrderDetailsOpen}
          order={orderData}
          userRights={userRights}
          comments={orderComments}
          summary={orderSummary}
          isSalesManager={isSalesManager || false}
          isSalesSupport={isSalesSupport || false}
          isAdmin={isAdmin || false}
          isSalesRep={isSalesRep || false}
        />
      )}
      <Button onClick={handleViewOrder}>{viewOrderButtonLabel}</Button>
    </>
  );
};

ViewOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrder;
